/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Change_RuleInputs */



/**
* | output |
* | --- |
* | "A more expensive type starts right away. A cheaper type starts at your next renewal, so you keep what you have already paid for." |
*
* @param {Seat_Change_RuleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_rule = /** @type {((inputs?: Seat_Change_RuleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_RuleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein teurerer Typ gilt sofort. Ein günstigerer Typ gilt ab Ihrer nächsten Verlängerung – so behalten Sie, was Sie bereits bezahlt haben.")
	return /** @type {LocalizedString} */ ("A more expensive type starts right away. A cheaper type starts at your next renewal, so you keep what you have already paid for.")
});